module.exports = "@value grey200 from \"colors.module.css\";\n\n.demo {\n  width: 500px;\n}\n"